import videojs from 'video.js'
import fr from 'video.js/dist/lang/fr.json'

videojs.addLanguage('fr', fr)
videojs.addLanguage('fr', {
  'Error': 'Erreur',
  'Error Code': "Code d'erreur",

  // custom french translations
  'subtitles off': 'Off',
  'captions off': 'Off',
  'audio off': 'Off',
  'Default': 'Prédéfini',
  'Unknown': 'Prédéfini',
  'subtitles_unavailable': 'Sous-titres non disponibles',
  'character_edge_style': 'Style des contours de caractères',
  'window_opacity': 'Opacité de la fenêtre',
  'window_color': 'Couleur de la fenêtre',
  'background_opacity': "Opacité de l'arrière-plan",
  'background_color': "Couleur de l'arrière-plan",
  'font_opacity': 'Opacité de la police',
  'font_size': 'Taille de la police',
  'font_color': 'Couleur de la police',
  'font_family': 'Famille de police',
  'custom_setting': 'Paramètres personnalisés',
  'Try again': 'Réessayer',
  'button_try_again_in': 'Réessayez dans {1}',
  'too_many_streams_title': 'Trop de diffusions',
  'stream_limit_exceeded_message':
    'Votre abonnement autorise {1} diffusions simultanées. Veuillez arrêter la lecture sur un autre appareil, puis réessayer.',
})
